// Fieldswell theme JS — Branded Axis
(function(){
if(window.Shopify&&Shopify.designMode){document.documentElement.classList.remove('js');var l=document.getElementById('loader');if(l)l.style.display='none';var v=document.getElementById('veil');if(v)v.style.display='none';return;}
})();
const veil=document.getElementById('veil');
const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('.split').forEach(el=>{
  const nodes=[...el.childNodes];el.textContent='';let i=0;
  function addWords(text,italic){
    text.split(/(\s+)/).forEach(part=>{
      if(!part)return;
      if(/^\s+$/.test(part)){el.appendChild(document.createTextNode(' '));return;}
      const w=document.createElement('span');w.className='w';
      const wi=document.createElement('span');wi.className='wi';
      wi.style.transitionDelay=(i*0.05)+'s';
      if(italic){const em=document.createElement('em');em.textContent=part;wi.appendChild(em);}
      else wi.textContent=part;
      w.appendChild(wi);el.appendChild(w);i++;
    });
  }
  nodes.forEach(n=>{
    if(n.nodeType===3)addWords(n.textContent,false);
    else if(n.nodeName==='EM')addWords(n.textContent,true);
    else if(n.nodeName==='BR')el.appendChild(document.createElement('br'));
    else addWords(n.textContent,false);
  });
});

// ---- reveal observer ----
const io=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
},{threshold:.15,rootMargin:'0px 0px -7% 0px'});
function observePage(page){
  page.querySelectorAll('.fade,.split,.mask,.phero-rule').forEach(el=>{el.classList.remove('in');io.observe(el);});
}


// ---- parallax ----
const plxEls=[...document.querySelectorAll('.plx')];
let ticking=false;
const isMobile=window.matchMedia('(max-width:760px)');
function parallax(){
  if(reduce||isMobile.matches){ticking=false;return;}
  const vh=window.innerHeight;
  plxEls.forEach(el=>{
    if(!el.closest('.page.active'))return;
    const r=el.getBoundingClientRect();
    if(r.bottom<0||r.top>vh)return;
    const sp=parseFloat(el.dataset.speed||0.1);
    const off=(r.top+r.height/2-vh/2)*sp;
    const im=el.querySelector('img');
    if(im)im.style.transform=`translateY(${off}px) scale(1.14)`;
  });
  ticking=false;
}
window.addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(parallax);}},{passive:true});

// ---- nav hide/show + clear-over-video ----
const hdr=document.getElementById('hdr');
let lastY=0;
function hdrClear(){
  const onVideo=document.querySelector('.vhero');
  hdr.classList.toggle('clear',!!onVideo&&window.scrollY<70);
}
window.addEventListener('scroll',()=>{
  const y=window.scrollY;
  if(y>460&&y>lastY+6)hdr.classList.add('hide');
  else if(y<lastY-6)hdr.classList.remove('hide');
  lastY=y;
  hdrClear();
},{passive:true});
const heroVid=document.querySelector('.vhero video');
if(heroVid&&reduce){heroVid.removeAttribute('autoplay');heroVid.pause();}


// ---- v4: mobile menu ----
const burger=document.getElementById('burger');
burger.addEventListener('click',()=>document.body.classList.toggle('menu-open'));
document.querySelectorAll('#mmenu a').forEach(a=>a.addEventListener('click',()=>document.body.classList.remove('menu-open')));

// ---- v4: rule draw + counters via observer ----
const io2=new IntersectionObserver(es=>{es.forEach(e=>{
  if(!e.isIntersecting)return;
  e.target.classList.add('in');
  const c=e.target.querySelector?e.target.querySelectorAll('[data-count]'):[];
  io2.unobserve(e.target);
})},{threshold:.4});
document.querySelectorAll('.phero-rule').forEach(el=>io2.observe(el));

const cio=new IntersectionObserver(es=>{es.forEach(e=>{
  if(!e.isIntersecting)return;
  const el=e.target,end=parseInt(el.dataset.count,10),t0=performance.now(),dur=1400;
  function step(t){const p=Math.min((t-t0)/dur,1);const ease=1-Math.pow(1-p,4);el.textContent=Math.round(end*ease);if(p<1)requestAnimationFrame(step);}
  requestAnimationFrame(step);cio.unobserve(el);
})},{threshold:.6});
document.querySelectorAll('[data-count]').forEach(el=>cio.observe(el));

// ---- v4: workshop hover preview ----
const wprev=document.getElementById('wprev');
const wimg=wprev.querySelector('img');
document.querySelectorAll('.wshop[data-img]').forEach(row=>{
  row.addEventListener('mouseenter',()=>{wimg.src=row.dataset.img;wprev.classList.add('show');});
  row.addEventListener('mouseleave',()=>wprev.classList.remove('show'));
  row.addEventListener('mousemove',e=>{
    wprev.style.left=(e.clientX+28)+'px';
    wprev.style.top=(e.clientY-90)+'px';
  });
});

// ---- v4: FAQ accordion ----
document.querySelectorAll('.faq-q').forEach(q=>{
  q.addEventListener('click',()=>{
    const item=q.parentElement,a=item.querySelector('.faq-a'),open=item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(o=>{o.classList.remove('open');o.querySelector('.faq-a').style.maxHeight='0px';});
    if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
  });
});

// ---- v10: contact interest pills ----
document.querySelectorAll('#ipills .ipill').forEach(p=>{
  p.addEventListener('click',()=>{
    document.querySelectorAll('#ipills .ipill').forEach(x=>x.classList.remove('on'));
    p.classList.add('on');
    const f=p.closest('form').querySelector('input[placeholder^="Discovery"]');
    if(f)f.value=p.textContent.trim();
  });
});



// ---- observe current document ----
if(!(window.Shopify&&Shopify.designMode)){observePage(document);}
// ---- veil page transitions on internal links ----
document.addEventListener('click',e=>{
  if(window.Shopify&&Shopify.designMode)return;
  const a=e.target.closest('a[href^="/"]');
  if(!a||a.target==='_blank'||e.metaKey||e.ctrlKey||reduce)return;
  e.preventDefault();document.body.classList.remove('menu-open');
  veil.classList.add('on');setTimeout(()=>{location.href=a.href;},600);
});
window.addEventListener('pageshow',e=>{if(e.persisted&&veil){veil.classList.add('snap');veil.classList.remove('on','out');requestAnimationFrame(()=>veil.classList.remove('snap'));}});
// ---- nav active state ----
(function(){
  const path=location.pathname.replace(/\/$/,'')||'/';
  document.querySelectorAll('[data-nav]').forEach(a=>{
    const ap=(a.getAttribute('href')||'').replace(/\/$/,'')||'/';
    if(ap===path)a.classList.add('on');
  });
})();
hdrClear();
parallax();
// ---- boot ----
const loader=document.getElementById('loader');
if(loader){window.addEventListener('load',()=>{setTimeout(()=>loader.classList.add('done'),700);});setTimeout(()=>loader.classList.add('done'),2400);}
document.addEventListener('shopify:section:load',()=>{if(!(window.Shopify&&Shopify.designMode))observePage(document);});

// v5.3: Ken Burns settle trigger for photo bands
(function(){
  if(!('IntersectionObserver' in window))return;
  var kio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('kb-in');kio.unobserve(e.target);}});},{threshold:.2});
  document.querySelectorAll('.breaker').forEach(function(b){kio.observe(b);});
})();
